<template>
	<l-circle
		:lat-lng="latLng"
		:radius="search.location.distance_max * 1000"
		color="rgba(69, 69, 69, var(--tw-bg-opacity))"
		:fill-opacity="0.0"
		v-if="search.location.distance_max"
	/>
</template>

<script>
import MapCenter from "./MapCenter.vue";

export default {
	mixins: [MapCenter],
};
</script>
